import React, { PureComponent } from 'react';
import { Currency } from '../../../../src/components/common/number'
import Text from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import styles from './summary-cash-accounts.styles';
import SummaryCashAccountsGrid from './summary-cash-accounts-grid';
import { RefreshIcon, Info2 } from '@dbk/ui-icons';
import { PALETTE, KEY_CODE } from '../../../constants';
import { LoadingCircle } from '../../../components/common/loading';
import { Toast } from '@dbk/ui-notifications';
import Popover from '@dbk/ui-popover';
import { StyleSheet } from 'react-native';
class SummaryCashAccounts extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showCashAccBanner: false,
      sortedColumnIndex: -1,
      sortedDirection: 0,
    }
  }

  componentDidMount = async () => {
    await this.props.cashAccounts.setSpinner(false);
    await this.props.cashAccounts.setServerError(false);
    await this.props.cashAccounts.getRTCashAccList();
    if(document.querySelector('.logo-web')){
      document.querySelector('.logo-web').focus();
    }

  }
  
  componentWillUnmount = async () => {
    await this.props.cashAccounts.setSpinner(false);
    await this.props.cashAccounts.setServerError(false);
  }
  
  async componentWillReceiveProps(nextProps) {
    this.setState({ showCashAccBanner: nextProps.cashAccounts.cashAccSummary ? nextProps.cashAccounts.cashAccSummary.hasMore : false });
    if (this.props.app.user.selectedPortfolioData.id !== nextProps.app.user.selectedPortfolioData.id) {
      this.setState({ sortedDirection: 0, sortedColumnIndex: -1 })
      await this.props.cashAccounts.getRTCashAccList();
    }
  }

  refreshClick = (e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
    this.props.cashAccounts.getRTCashAccList();
    }
  }

  sortHandler = (sortedColumnIndex, sortedDirection) => {
    this.setState({
      sortedColumnIndex,
      sortedDirection
    })
  }

  render() {
    const { cashAccounts: { showSpinner, serverError, cashAccSummary, destinationCcy }, i18n: { messages }, languages: { destLanguage } } = this.props;
    if (serverError) {
      return (
        <div className="currencyChartNoData">
          <Text>{messages['app.rsa.serverError']}</Text>
        </div>
      );
    }
    else if (showSpinner || cashAccSummary === null || cashAccSummary === undefined)
      return <div className="portfolio-ldng-crcle"><LoadingCircle /></div>
    else if (cashAccSummary) {
      return (
        <div className="cash-container">
          {(!cashAccSummary.hasMore && cashAccSummary.cashAccList && cashAccSummary.cashAccList.length) ?
            <React.Fragment>
                <div className="mkt-val-refresh-icon">
                <div className="total-mkt-val-Qmark">
                  <div tabIndex={0}>
                    <Text size={"large"} secondary className="cashAccountsMktHeader">{messages['app.cashAccounts.label.totalMktValue']}</Text>
                  </div>
                  <Popover
                    tabIndex={0}
                    mode="popup"
                    orientation="right"
                    showOnHover
                    popOverClassName="total-mkt-val-popover"
                    arrowColor={PALETTE.secondaryActive}
                    content={<div>{messages["app.cashAccounts.summary.totalMktValPopoverContent"]}</div>}
                  >
                    <div aria-label={messages['app.cashAccounts.marketValueInfo']+ " " + messages['app.cashAccounts.summary.totalMktValPopoverContent']}>
                      <Info2 className="cash-total-mkt-val-Qmark" color={PALETTE.primaryText} height={29} width={29}/>
                    </div>
                  </Popover>
                </div>
                <div className='cash-curr-refresh'>
                  <div tabIndex={0}>
                    <Currency
                      signBeforeNumber={false}
                      decimalStyle={StyleSheet.flatten(styles.decimalStyle)}
                      currencyStyle={StyleSheet.flatten(styles.currencyStyle)}
                      currency={destinationCcy}
                      renderProps={{
                        style: styles.marketValueText,
                        size: 40,
                        testID: 'market-value',
                      }}
                      value={cashAccSummary.totalMktVal}
                    />
                  </div>
                  
                  <span onKeyDown={(e) => this.refreshClick(e)} onClick={() => this.refreshClick()} aria-label={messages['app.payments.refreshPayment']} role="button" tabIndex={0}>
                    <RefreshIcon className="pointer" id='refresh' width={25} height={30} color={PALETTE.secondaryActive} />
                  </span>
                </div>
              </div>
            </React.Fragment>
            : <div className='mktValHeight' />}
          {this.state.showCashAccBanner &&
            <Toast className="cashAccBanner" underline status="error" onClose={() => { this.setState({ showCashAccBanner: false }) }}>
              {messages["app.cashAccounts.cashSummaryDetails.exceedRecords"]}</Toast>}
          <SummaryCashAccountsGrid cashAccSummary={cashAccSummary}
            onSortChange={this.sortHandler} sortedColumnIndex={this.state.sortedColumnIndex} sortedDirection={this.state.sortedDirection}
            showCashAccBanner={this.state.showCashAccBanner} />
        </div>
      )
    }
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true
    },
    cashAccounts: {
      getRTCashAccList: { $call: 'getRTCashAccList' },
      cashAccSummary: true,
      showSpinner: true,
      setSpinner: { $set: 'showSpinner' },
      serverError: true,
      setServerError: { $set: 'serverError' },
      destinationCcy: true
    },
    app: {
      user: {
        selectedPortfolioData: true,
      }
    },
    languages: {
      destLanguage: true
    }
  }
})(SummaryCashAccounts);